/* eslint-disable array-callback-return, eqeqeq */
import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Select from "react-select";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import duration from "dayjs/plugin/duration";
import Fab from "@material-ui/core/Button";

import icon_realtime from "assets/images/icon-realtime.png";
import icon_edit from "assets/images/icon-edit-cat.png";
import icon_delete from "assets/images/icon-delete.svg";
import chroma from "chroma-js";
import icon_body from "assets/images/icon-body.png";
import icon_chest from "assets/images/icon-chest.png";
import icon_heart from "assets/images/icon-heart.png";
import icon_sleep from "assets/images/icon-sleep.png";
import icon_beats from "assets/images/icon-beats.png";
import icon_check from "assets/images/icon-check.png";
import icon_check_white from "assets/images/icon-check-white.png";
import icon_spo2 from "assets/images/icon-heart.png";
import icon_pulse_rate from "assets/images/icon-beats.png";
import IntlMessages from "util/IntlMessages";

const kpi_details = {
  Y_DIST: {
    name: "Chest Displacement",
    img: <img src={icon_chest} alt="Chest Displacement" />,
    icon: <img src={icon_check} alt="Chest Displacement" />,
  },
  MOV: {
    name: "Body Movement",
    img: <img src={icon_body} alt="Body Movement" />,
    icon: <img src={icon_check} alt="Body Movement" />,
  },
  BR: {
    name: "Breathing Rate",
    img: <img src={icon_heart} alt="Breathing Rate" />,
    icon: <img src={icon_check} alt="Breathing Rate" />,
  },
  BRV: {
    name: "BR Variability",
    img: <img src={icon_heart} alt="Breathing Rate Variability" />,
    icon: <img src={icon_check} alt="Breathing Rate Variability" />,
  },
  HR: {
    name: "Heart Rate Radar",
    img: <img src={icon_beats} alt="Heart Rate Radar" />,
    icon: <img src={icon_check} alt="Heart Rate Radar" />,
  },
  HRV: {
    name: "HR Variability",
    img: <img src={icon_beats} alt="Heart Rate Variability" />,
    icon: <img src={icon_check} alt="Heart Rate Variability" />,
  },
  SPO2: {
    name: "SPO2",
    img: <img src={icon_spo2} alt="SPO2" />,
    icon: <img src={icon_check} alt="SPO2" />,
  },
  PR: {
    name: "Pulse Rate",
    img: <img src={icon_pulse_rate} alt="Pulse Rate" />,
    icon: <img src={icon_check} alt="Pulse Rate" />,
  },
  I: {
    name: "I",
    img: <img src={icon_realtime} alt="I" />,
    icon: <img src={icon_check} alt="I" />,
  },
  Q: {
    name: "Q",
    img: <img src={icon_realtime} alt="Q" />,
    icon: <img src={icon_check} alt="Q" />,
  },
  IQ: {
    name: "IQ",
    img: <img src={icon_realtime} alt="IQ" />,
    icon: <img src={icon_check} alt="IQ" />,
  },
  SA: {
    name: "Sleep Awake",
    img: <img src={icon_sleep} alt="Sleep Awake" />,
    icon: <img src={icon_check} alt="Sleep Awake" />,
  },
  TB: {
    name: "Time in Bed",
    img: <img src={icon_sleep} alt="Time in Bed" />,
    icon: <img src={icon_check} alt="Time in Bed" />,
  },
};

const initial_input_time_ranges = {
  min_hh: null,
  min_hh_span: false,
  min_mm: null,
  min_mm_span: false,
  min_ss: null,
  min_ss_span: false,
  max_hh: null,
  max_hh_span: false,
  max_mm: null,
  max_mm_span: false,
  max_ss: null,
  max_ss_span: false,
};

dayjs.extend(utc);
dayjs.extend(duration);

export default function FormDialog(props) {
  const {
    selected_night,
    sorted_kpis,
    annotate,
    recording_date,
    device_id,
    set_annotate,
    setKeyComboValue,
    annotate_range,
    set_annotate_range,
    selected_kpis,

    add_new_annotation,
    edit_annotation,
    annotation_colours,

    annotation_categories,
    add_annotation_category,
    edit_annotation_category,
    delete_annotation_category,

    patient_id,
    doctor_id,
    is_annotator,
    patient_physician_id,

    selected_annotation,
    annotation_map_id,
    set_annotation_map_id,
    edit_annotation_flag,
    set_edit_annotation_flag,
    view_annotation_flag,
    set_view_annotation_flag,
    showEditAnnotationPopup,
  } = props;
  const [annotation_kpis, change_annotation_kpis] = useState({});

  const [show_category_listing_flag, set_show_category_listing_flag] = useState(
    true
  );
  const [show_add_category_flag, set_show_add_category_flag] = useState(false);
  const [show_edit_category_flag, set_show_edit_category_flag] = useState(
    false
  );

  const [selected_kpi_error, set_selected_kpi_error] = useState("");

  const [comment, update_comment] = useState("");
  const [comment_error, set_comment_error] = useState("");

  const [time_difference, set_time_difference] = useState(null);
  const [
    time_difference_in_milliseconds,
    set_time_difference_in_milliseconds,
  ] = useState(0);
  const [time_difference_error, set_time_difference_error] = useState(null);

  const [category, update_category] = useState({});
  const [category_error, set_category_error] = useState(null);

  const [add_category_label, set_add_category_label] = useState("");
  const [add_category_label_error, set_add_category_label_error] = useState(
    null
  );
  const [add_category_color_code, set_add_category_color_code] = useState("");
  const [
    add_category_color_code_error,
    set_add_category_color_code_error,
  ] = useState(null);

  const [edit_category_label_id, set_edit_category_label_id] = useState(null);
  const [edit_category_label, set_edit_category_label] = useState("");
  const [edit_category_label_error, set_edit_category_label_error] = useState(
    null
  );
  const [edit_category_color_option, set_edit_category_color_option] = useState(
    {}
  );
  const [edit_category_color_code, set_edit_category_color_code] = useState("");
  const [
    edit_category_color_code_error,
    set_edit_category_color_code_error,
  ] = useState(null);

  const [
    available_add_category_colours,
    set_available_add_category_colours,
  ] = useState([]);
  const [
    available_edit_category_colours,
    set_available_edit_category_colours,
  ] = useState([]);

  const [input_time_ranges, set_input_time_ranges] = useState(
    initial_input_time_ranges
  );

  const resetAddAnnotation = () => {
    set_selected_kpi_error(null);

    set_time_difference_error(null);

    update_comment("");
    set_comment_error(null);
    set_input_time_ranges(initial_input_time_ranges);

    update_category({});
    set_category_error(null);

    set_show_category_listing_flag(true);
    set_show_add_category_flag(false);
    set_show_edit_category_flag(false);
  };

  const handleClose = () => {
    set_annotate(false);
    set_annotation_map_id(null);
    set_edit_annotation_flag(false);
    set_view_annotation_flag(false);

    resetAddAnnotation();
  };

  const select_kpi = (kpi) => {
    let is_added = true;

    if (!annotation_kpis[kpi]) {
      is_added = false;
    }

    change_annotation_kpis({
      ...annotation_kpis,
      [kpi]: !is_added,
    });
  };

  const select_category = (c_data) => {
    update_category(c_data);
  };

  const validateAnnotationRange = (event) => {
    const eventCode = event.which || event.keyCode || 0;
    const value = parseInt(event.target.value + String.fromCharCode(eventCode));
    if (
      !(
        eventCode >= 48 ||
        eventCode <= 57 ||
        eventCode == 8 ||
        eventCode == 46
      ) ||
      isNaN(value)
    ) {
      event.preventDefault();
    }
  };

  const updateAnnotationRange = (range, type, value) => {
    if (
      (type === "hh" && (value < 0 || value > 23)) ||
      ((type === "mm" || type === "ss") && (value < 0 || value > 59))
    ) {
      set_input_time_ranges({
        ...input_time_ranges,
        [range + "_" + type]: parseInt(value),
      });
      return;
    } else {
      if (range && type) {
        set_input_time_ranges({
          ...input_time_ranges,
          [range + "_" + type]: null,
        });
      }
    }

    const rangeTime = annotate_range;

    if (range === "min") {
      if (type === "hh") {
        rangeTime[0] = dayjs
          .utc(rangeTime[0])
          .hour(value)
          .toDate();
      } else if (type === "mm") {
        rangeTime[0] = dayjs
          .utc(rangeTime[0])
          .minute(value)
          .toDate();
      } else if (type === "ss") {
        rangeTime[0] = dayjs
          .utc(rangeTime[0])
          .second(value)
          .toDate();
      }
    } else if (range === "max") {
      if (type === "hh") {
        rangeTime[1] = dayjs
          .utc(rangeTime[1])
          .hour(value)
          .toDate();
      } else if (type === "mm") {
        rangeTime[1] = dayjs
          .utc(rangeTime[1])
          .minute(value)
          .toDate();
      } else if (type === "ss") {
        rangeTime[1] = dayjs
          .utc(rangeTime[1])
          .second(value)
          .toDate();
      }
    }

    const diffTime = dayjs.duration(
      dayjs.utc(rangeTime[1]).diff(dayjs.utc(rangeTime[0]))
    );
    const formatedDiffTime = [];
    formatedDiffTime[0] = diffTime.hours() + diffTime.days() * 24;
    formatedDiffTime[1] = diffTime.minutes();
    formatedDiffTime[2] = diffTime.seconds();

    set_time_difference_in_milliseconds(diffTime.valueOf());
    set_time_difference(formatedDiffTime);
    set_annotate_range(rangeTime);
  };

  const validate_add_annotation = () => {
    let isValid = true;

    if (
      Object.keys(annotation_kpis).filter((k) => annotation_kpis[k] === true)
        .length === 0
    ) {
      set_selected_kpi_error("Please select at least one KPI.");
      isValid = false && isValid;
    } else {
      set_selected_kpi_error(null);
      isValid = true && isValid;
    }

    const form_input_time_ranges = { ...input_time_ranges };

    if (input_time_ranges.min_hh < 0 || input_time_ranges.min_hh > 23) {
      form_input_time_ranges.min_hh_span = true;
    } else {
      form_input_time_ranges.min_hh_span = false;
    }

    if (input_time_ranges.min_mm < 0 || input_time_ranges.min_mm > 59) {
      form_input_time_ranges.min_mm_span = true;
    } else {
      form_input_time_ranges.min_mm_span = false;
    }

    if (input_time_ranges.min_ss < 0 || input_time_ranges.min_ss > 59) {
      form_input_time_ranges.min_ss_span = true;
    } else {
      form_input_time_ranges.min_ss_span = false;
    }

    if (input_time_ranges.max_hh < 0 || input_time_ranges.max_hh > 23) {
      form_input_time_ranges.max_hh_span = true;
    } else {
      form_input_time_ranges.max_hh_span = false;
    }

    if (input_time_ranges.max_mm < 0 || input_time_ranges.max_mm > 59) {
      form_input_time_ranges.max_mm_span = true;
    } else {
      form_input_time_ranges.max_mm_span = false;
    }

    if (input_time_ranges.max_ss < 0 || input_time_ranges.max_ss > 59) {
      form_input_time_ranges.max_ss_span = true;
    } else {
      form_input_time_ranges.max_ss_span = false;
    }

    set_input_time_ranges({
      ...input_time_ranges,
      ...form_input_time_ranges,
    });

    if (
      time_difference_in_milliseconds <= 0 ||
      Object.values(form_input_time_ranges).indexOf(true) > 0
    ) {
      set_time_difference_error("Please select valid annotation duration.");
      isValid = false && isValid;
    } else {
      set_time_difference_error(null);
      isValid = true && isValid;
    }

    if (!category || (category && Object.keys(category).length === 0)) {
      set_category_error("Please select a category.");
      isValid = false && isValid;
    } else {
      set_category_error(null);
      isValid = true && isValid;
    }

    return isValid;
  };

  const addApneaAnnotationHandler = (annotate_range) => {
    const kpiList = [];
    Object.keys(annotation_kpis).map((kpi) => {
      kpiList.push(kpi);
    });
    if (kpiList.includes("IQ")) {
      kpiList.push("I", "Q");
    }
    const strKpiList = kpiList.join(",");

    const annotation_data = {
      type: "custom",
      night: dayjs.unix(selected_night).format("YYYY-MM-DD 05:30:00"),
      kpi: strKpiList,
      start_time: dayjs.utc(annotate_range[0]).format("YYYY-MM-DD HH:mm:ss"),
      end_time: dayjs
        .utc(annotate_range[0])
        .add(10, "seconds")
        .format("YYYY-MM-DD HH:mm:ss"),
      duration: "0:0:10",
      comment: comment.replace(/\\/g, "\\\\").replace(/'/g, "\\'"),
      label: 1,
      color_code: "#DA7171",
      patient_id,
      doctor_id: is_annotator ? patient_physician_id : doctor_id,
      created_by: doctor_id,
      updated_by: doctor_id,
      created_date: dayjs.utc().format("YYYY-MM-DD HH:mm:ss"),
      updated_date: dayjs.utc().format("YYYY-MM-DD HH:mm:ss"),
    };

    add_new_annotation({
      ...annotation_data,
      device_id,
      recording_date,
    });
    set_annotate(false);
    resetAddAnnotation();
  };

  const addAnnotationHandler = (kpiAnnotations) => {
    const isValid = validate_add_annotation();
    if (!isValid) {
      return false;
    }

    let kpiList = [];
    Object.keys(kpiAnnotations).map((kpi) => {
      if (kpiAnnotations[kpi]) kpiList.push(kpi);
    });
    if (kpiList.includes("IQ")) {
      kpiList.push("I", "Q");
    }
    const strKpiList = kpiList.join(",");

    const annotation_data = {
      type: "custom",
      night: dayjs.unix(selected_night).format("YYYY-MM-DD 05:30:00"),
      kpi: strKpiList,
      start_time: dayjs.utc(annotate_range[0]).format("YYYY-MM-DD HH:mm:ss"),
      end_time: dayjs.utc(annotate_range[1]).format("YYYY-MM-DD HH:mm:ss"),
      duration:
        time_difference[0] +
        ":" +
        time_difference[1] +
        ":" +
        time_difference[2],
      comment: comment.replace(/\\/g, "\\\\").replace(/'/g, "\\'"),
      label: category.label_id,
      color_code: category.color_code,
      patient_id,
      doctor_id: is_annotator ? patient_physician_id : doctor_id,
      created_by: doctor_id,
      updated_by: doctor_id,
      created_date: dayjs.utc().format("YYYY-MM-DD HH:mm:ss"),
      updated_date: dayjs.utc().format("YYYY-MM-DD HH:mm:ss"),
    };

    add_new_annotation({
      ...annotation_data,
      device_id,
      recording_date,
    });

    set_annotate(false);
    resetAddAnnotation();
  };

  useEffect(
    () => {
      if (setKeyComboValue.current && annotate_range) {
        addApneaAnnotationHandler(annotate_range);
        set_annotate(false);
      }
    },
    [setKeyComboValue, set_annotate_range, annotate_range]
  );

  const editAnnotationHandler = () => {
    const isValid = validate_add_annotation();
    if (!isValid) {
      return false;
    }

    const kpiList = [];
    Object.keys(annotation_kpis).map((kpi) => {
      if (annotation_kpis[kpi]) {
        kpiList.push(kpi);
      }
    });

    if (kpiList.includes("IQ")) {
      kpiList.push("I", "Q");
    }

    let annotationType = selected_annotation.type;
    if (selected_annotation.type === "system") {
      annotationType = "system-edit";
    }

    const data = {
      delete_flag: 0,
      annotation_map_id,
      type: annotationType,
      night: selected_annotation.night,
      kpi: kpiList.join(","),
      start_time: dayjs.utc(annotate_range[0]).format("YYYY-MM-DD HH:mm:ss"),
      end_time: dayjs.utc(annotate_range[1]).format("YYYY-MM-DD HH:mm:ss"),
      duration:
        time_difference[0] +
        ":" +
        time_difference[1] +
        ":" +
        time_difference[2],
      comment: comment.replace(/\\/g, "\\\\").replace(/'/g, "\\'"),
      label: category.label_id,
      color_code: category.color_code,
      patient_id,
      updated_by: doctor_id,
      doctor_id: is_annotator ? patient_physician_id : doctor_id,
      updated_date: dayjs.utc().format("YYYY-MM-DD HH:mm:ss"),
    };

    edit_annotation({
      ...data,
      device_id,
      recording_date,
    });
    handleClose();
  };

  const deleteAnnotationHandler = () => {
    const status = window.confirm("Are you sure to delete this annotation ?");
    if (!status) {
      return false;
    }

    const kpiList = [];
    Object.keys(annotation_kpis).map((kpi) => {
      if (annotation_kpis[kpi]) {
        kpiList.push(kpi);
      }
    });

    if (kpiList.includes("IQ")) {
      kpiList.push("I", "Q");
    }

    const data = {
      delete_flag: 1,
      annotation_map_id,
      type: selected_annotation.type,
      night: selected_annotation.night,
      kpi: kpiList.join(","),
      start_time: dayjs.utc(annotate_range[0]).format("YYYY-MM-DD HH:mm:ss"),
      end_time: dayjs.utc(annotate_range[1]).format("YYYY-MM-DD HH:mm:ss"),
      duration:
        time_difference[0] +
        ":" +
        time_difference[1] +
        ":" +
        time_difference[2],
      comment: comment.replace(/\\/g, "\\\\").replace(/'/g, "\\'"),
      label: category.label_id,
      color_code: category.color_code,
      patient_id,
      doctor_id: is_annotator ? patient_physician_id : doctor_id,
      updated_date: dayjs.utc().format("YYYY-MM-DD HH:mm:ss"),
    };

    edit_annotation({
      ...data,
      device_id,
      recording_date,
    });
    handleClose();
  };

  const showNewLabelHandle = () => {
    set_show_category_listing_flag(false);
    set_show_edit_category_flag(false);
    set_show_add_category_flag(true);
  };

  const hideNewLabelHandle = () => {
    set_show_add_category_flag(false);
    set_show_edit_category_flag(false);
    set_show_category_listing_flag(true);

    resetAddCategoryHandle();
  };

  const validate_add_category = () => {
    let isValid = true;

    if (add_category_color_code === "") {
      set_add_category_color_code_error("Please select a color.");
      isValid = false && isValid;
    } else {
      set_add_category_color_code_error(null);
      isValid = true && isValid;
    }

    if (add_category_label.trim().length === 0) {
      set_add_category_label_error("Please enter category.");
      isValid = false && isValid;
    } else if (add_category_label.length > 20) {
      set_add_category_label_error(
        "Category length should not exceed 20 characters."
      );
      isValid = false && isValid;
    } else {
      set_add_category_label_error(null);
      isValid = true && isValid;
    }

    return isValid;
  };

  const resetAddCategoryHandle = () => {
    set_add_category_color_code("");
    set_add_category_color_code_error(null);

    set_add_category_label("");
    set_add_category_label_error(null);
  };

  const addCategoryHandle = () => {
    const isValid = validate_add_category();
    if (!isValid) {
      return false;
    }

    const data = {
      patient_id: patient_id,
      doctor_id: is_annotator ? patient_physician_id : doctor_id,
      label: add_category_label.replace(/\\/g, "\\\\").replace(/'/g, "\\'"),
      color_code: add_category_color_code,
      created_date: dayjs.utc().format("YYYY-MM-DD HH:mm:ss"),
      created_by: is_annotator ? patient_physician_id : doctor_id,
      updated_date: dayjs.utc().format("YYYY-MM-DD HH:mm:ss"),
      updated_by: is_annotator ? patient_physician_id : doctor_id,
      type: "custom",
    };

    add_annotation_category(data);
    hideNewLabelHandle();
  };

  const showEditLabelHandle = (category_label_id) => {
    const edit_category_details = annotation_categories.find(
      (c) => c.label_id === category_label_id
    );
    set_edit_category_label_id(category_label_id);
    set_edit_category_label(edit_category_details.label);
    set_edit_category_color_code(edit_category_details.color_code);

    const edit_category_color_details = annotation_colours.find(
      (c) => c.value === edit_category_details.color_code
    );
    set_edit_category_color_option(edit_category_color_details);

    const colors = [...available_add_category_colours];
    colors.push(edit_category_color_details);
    set_available_edit_category_colours(colors);

    set_show_category_listing_flag(false);
    set_show_add_category_flag(false);
    set_show_edit_category_flag(true);
  };

  const hideEditLabelHandle = () => {
    set_show_add_category_flag(false);
    set_show_edit_category_flag(false);
    set_show_category_listing_flag(true);
  };

  const validate_edit_category = () => {
    let isValid = true;

    if (edit_category_color_code === "") {
      set_edit_category_color_code_error("Please select a color.");
      isValid = false && isValid;
    } else {
      set_edit_category_color_code_error(null);
      isValid = true && isValid;
    }

    if (edit_category_label.trim().length === 0) {
      set_edit_category_label_error("Please enter category.");
      isValid = false && isValid;
    } else if (edit_category_label.length > 20) {
      set_edit_category_label_error(
        "Category length should not exceed 20 characters."
      );
      isValid = false && isValid;
    } else {
      set_edit_category_label_error(null);
      isValid = true && isValid;
    }

    return isValid;
  };

  const editCategoryHandle = () => {
    const isValid = validate_edit_category();
    if (!isValid) {
      return false;
    }

    const data = {
      doctor_id: is_annotator ? patient_physician_id : doctor_id,
      label_id: edit_category_label_id,
      label: edit_category_label.replace(/\\/g, "\\\\").replace(/'/g, "\\'"),
      color_code: edit_category_color_code,
      updated_date: dayjs.utc().format("YYYY-MM-DD HH:mm:ss"),
      updated_by: is_annotator ? patient_physician_id : doctor_id,
      type: annotation_categories.find(
        (c) => c.label_id === edit_category_label_id
      ).type,
    };

    edit_annotation_category(data);
    hideEditLabelHandle();
  };

  const deleteCategoryHandle = (label_id) => {
    const status = window.confirm("Are you sure to delete this category ?");
    if (status) {
      const data = {
        doctor_id: is_annotator ? patient_physician_id : doctor_id,
        label_id: label_id,
      };

      delete_annotation_category(data);
    }
  };

  const dot = (color = "#ccc") => ({
    alignItems: "center",
    display: "flex",

    ":before": {
      backgroundColor: color,
      borderRadius: 4,
      content: '" "',
      display: "block",
      marginRight: 8,
      height: 22,
      width: 42,
    },
  });

  const colourStyles = {
    control: (styles) => ({ ...styles, backgroundColor: "white" }),
    option: (styles, { data, isFocused, isSelected }) => {
      const color = chroma(data.value);
      return {
        ...styles,
        backgroundColor: isSelected
          ? data.value
          : isFocused
            ? color.alpha(0.8).css()
            : data.value,
        backgroundImage: isSelected ? `url(${icon_check_white})` : "none",
        backgroundRepeat: isSelected ? "no-repeat" : "unset",
        backgroundPosition: isSelected ? "center center" : "unset",
        backgroundSize: isSelected ? "10px auto" : "auto",
        height: "17px",
        marginTop: "5px",
        borderRadius: "4px",
        ":active": {
          ...styles[":active"],
          backgroundColor: isSelected ? data.value : color.alpha(0.3).css(),
        },
      };
    },
    singleValue: (styles, { data }) => ({ ...styles, ...dot(data.value) }),
  };

  useEffect(
    () => {
      if (annotate_range && annotate_range.length > 0) {
        updateAnnotationRange();
      }
    },
    [annotate_range]
  );

  useEffect(
    () => {
      if (annotation_map_id && annotation_map_id > 0) {
        set_annotate_range([
          selected_annotation.start_date,
          selected_annotation.end_date,
        ]);
        update_comment(selected_annotation.comment);
        update_category(
          annotation_categories.find(
            (c) => c.label_id === selected_annotation.label_id
          )
        );

        const kList = {};
        Object.keys(selected_annotation.kpiList).map((k) => {
          kList[k] = true;
        });

        change_annotation_kpis({
          ...kList,
        });
      }
    },
    [annotation_map_id]
  );

  useEffect(
    () => {
      if (!edit_annotation_flag && !view_annotation_flag && selected_kpis) {
        change_annotation_kpis({
          ...selected_kpis,
        });
      }
    },
    [edit_annotation_flag, view_annotation_flag, selected_kpis]
  );

  useEffect(
    () => {
      if (annotation_categories && annotation_categories.length > 0) {
        const colors = annotation_colours.filter(function(o1) {
          return !annotation_categories.some(function(o2) {
            return o1.value === o2.color_code;
          });
        });

        set_available_add_category_colours(colors);
      }
    },
    [annotation_categories]
  );

  return (
    <Dialog
      fullWidth={true}
      className="custom-popup annotation-popup"
      PaperProps={{ classes: { root: "annotation-popup-root" } }}
      open={annotate}
      onClose={handleClose}
      disableBackdropClick={true}
    >
      <div className="popup-wrap annotation-popup-wrap">
        <div className="popup-header">
          <DialogTitle className="popup-title">
            {!edit_annotation_flag && !view_annotation_flag && "Add Annotation"}
            {edit_annotation_flag && "Edit Annotation"}
            {view_annotation_flag && "View Annotation"}
          </DialogTitle>
          <div className="popup-header-right">
            {view_annotation_flag && (
              <span className="add-date">
                Added on{" "}
                {dayjs
                  .utc(selected_annotation.created_date)
                  .format("DD MMM | HH:mm")}
              </span>
            )}
            {(view_annotation_flag || edit_annotation_flag) && (
              <Button
                className="popup-action popup-delete"
                disableRipple={true}
                disableFocusRipple={true}
                onClick={() => deleteAnnotationHandler()}
              >
                <IntlMessages id="button.delete" />
              </Button>
            )}
            {view_annotation_flag && (
              <Button
                className="popup-action popup-edit"
                disableRipple={true}
                disableFocusRipple={true}
                onClick={() =>
                  showEditAnnotationPopup(selected_annotation.annotation_map_id)
                }
              >
                <IntlMessages id="myprofile.edit" />
              </Button>
            )}
            <Button
              className="popup-close"
              disableRipple={true}
              disableFocusRipple={true}
              onClick={handleClose}
            >
              <i className="zmdi zmdi-close zmdi-hc-fw" />
            </Button>
          </div>
        </div>

        <DialogContent className="popup-content">
          <div className="annotation-block kpilist-block">
            <div className="kpilist-title">
              <IntlMessages id="ea.msg" />
            </div>
            <ul className="list-inline list-inline-3">
              {annotation_map_id &&
                view_annotation_flag &&
                selected_annotation &&
                selected_annotation.kpi &&
                Object.keys(selected_annotation.kpiList).map((k) => {
                  return (
                    <li key={k} className="list-inline-item filter-item">
                      <Fab
                        variant="contained"
                        disableRipple={true}
                        disableFocusRipple={true}
                        className="bg-blue text-white"
                        classes={{ label: "kpi-label" }}
                      >
                        <span className="filter-icon">
                          {kpi_details[k].img}
                        </span>
                        <span className="filter-text">
                          {kpi_details[k].name}
                        </span>
                        <span className="check-icon">
                          {kpi_details[k].icon}
                        </span>
                      </Fab>
                    </li>
                  );
                })}
              {!view_annotation_flag &&
                sorted_kpis &&
                sorted_kpis.length > 0 &&
                sorted_kpis.map((kpi) => {
                  // if (kpi === "STAGES") return;
                  if (!kpi_details[kpi]) return;

                  return (
                    <li
                      key={kpi}
                      kpi_name={kpi_details[kpi].name}
                      className="list-inline-item filter-item"
                    >
                      <Fab
                        variant="contained"
                        disableRipple={true}
                        disableFocusRipple={true}
                        className={`${
                          annotation_kpis[kpi] ? "bg-blue text-white" : ""
                        }`}
                        onClick={() => select_kpi(kpi)}
                        classes={{ label: "kpi-label" }}
                      >
                        <span className="filter-icon">
                          {kpi_details[kpi].img}
                        </span>
                        <span className="filter-text">
                          {kpi_details[kpi].name}
                        </span>
                        <span className="check-icon">
                          {kpi_details[kpi].icon}
                        </span>
                      </Fab>
                    </li>
                  );
                })}
              {selected_kpi_error && (
                <span className="error-msg">{selected_kpi_error}</span>
              )}
            </ul>
          </div>
          <div className="annotation-block duration-block">
            {annotate_range &&
              annotate_range.length === 2 && (
                <div>
                  <div className="duration-title">GMT +1, 24h, HH:MM:SS</div>
                  <div className="time-wrap">
                    <div className="time-block start-block">
                      <div className="time-label">{"Start date & time"}</div>
                      <div className="date-label">
                        <span>
                          {dayjs.utc(annotate_range[0]).format("DD MMM")}
                        </span>
                      </div>
                      {view_annotation_flag && (
                        <div className="time-container view-time-container">
                          <span>
                            {dayjs.utc(annotate_range[0]).format("HH")}
                          </span>
                          <small>:</small>
                          <span>
                            {dayjs.utc(annotate_range[0]).format("mm")}
                          </span>
                          <small>:</small>
                          <span>
                            {dayjs.utc(annotate_range[0]).format("ss")}
                          </span>
                        </div>
                      )}
                      {!view_annotation_flag && (
                        <div className="time-container">
                          <span
                            className={
                              input_time_ranges.min_hh_span
                                ? "input-range-error"
                                : ""
                            }
                          >
                            <TextField
                              type="number"
                              InputProps={{
                                inputProps: { min: 0, max: 23 },
                                classes: { root: "time-field-root" },
                              }}
                              className="time-field"
                              defaultValue={dayjs
                                .utc(annotate_range[0])
                                .format("HH")}
                              onChange={(e) =>
                                updateAnnotationRange(
                                  "min",
                                  "hh",
                                  e.target.value
                                )
                              }
                              onKeyPress={(e) =>
                                validateAnnotationRange(e, "hh")
                              }
                              onPaste={(e) => e.preventDefault()}
                              onDrop={(e) => e.preventDefault()}
                              onWheelCapture={(e) => {
                                e.target.blur();
                              }}
                            />
                          </span>
                          <small>:</small>
                          <span
                            className={
                              input_time_ranges.min_mm_span
                                ? "input-range-error"
                                : ""
                            }
                          >
                            <TextField
                              type="number"
                              InputProps={{
                                inputProps: { min: 0, max: 59 },
                                classes: { root: "time-field-root" },
                              }}
                              className="time-field"
                              defaultValue={dayjs
                                .utc(annotate_range[0])
                                .format("mm")}
                              onChange={(e) =>
                                updateAnnotationRange(
                                  "min",
                                  "mm",
                                  e.target.value
                                )
                              }
                              onKeyPress={(e) =>
                                validateAnnotationRange(e, "mm")
                              }
                              onPaste={(e) => e.preventDefault()}
                              onDrop={(e) => e.preventDefault()}
                              onWheelCapture={(e) => {
                                e.target.blur();
                              }}
                            />
                          </span>
                          <small>:</small>
                          <span
                            className={
                              input_time_ranges.min_ss_span
                                ? "input-range-error"
                                : ""
                            }
                          >
                            <TextField
                              type="number"
                              InputProps={{
                                inputProps: { min: 0, max: 59 },
                                classes: { root: "time-field-root" },
                              }}
                              className="time-field"
                              defaultValue={dayjs
                                .utc(annotate_range[0])
                                .format("ss")}
                              onChange={(e) =>
                                updateAnnotationRange(
                                  "min",
                                  "ss",
                                  e.target.value
                                )
                              }
                              onKeyPress={(e) =>
                                validateAnnotationRange(e, "ss")
                              }
                              onPaste={(e) => e.preventDefault()}
                              onDrop={(e) => e.preventDefault()}
                              onWheelCapture={(e) => {
                                e.target.blur();
                              }}
                            />
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="time-block end-block">
                      <div className="time-label">{"End date & time"}</div>
                      <div className="date-label">
                        <span>
                          {dayjs.utc(annotate_range[1]).format("DD MMM")}
                        </span>
                      </div>
                      {view_annotation_flag && (
                        <div className="time-container view-time-container">
                          <span>
                            {dayjs.utc(annotate_range[1]).format("HH")}
                          </span>
                          <small>:</small>
                          <span>
                            {dayjs.utc(annotate_range[1]).format("mm")}
                          </span>
                          <small>:</small>
                          <span>
                            {dayjs.utc(annotate_range[1]).format("ss")}
                          </span>
                        </div>
                      )}
                      {!view_annotation_flag && (
                        <div className="time-container">
                          <span
                            className={
                              input_time_ranges.max_hh_span
                                ? "input-range-error"
                                : ""
                            }
                          >
                            <TextField
                              type="number"
                              InputProps={{
                                inputProps: { min: 0, max: 23 },
                                classes: { root: "time-field-root" },
                              }}
                              className="time-field"
                              defaultValue={dayjs
                                .utc(annotate_range[1])
                                .format("HH")}
                              onChange={(e) =>
                                updateAnnotationRange(
                                  "max",
                                  "hh",
                                  e.target.value
                                )
                              }
                              onKeyPress={(e) =>
                                validateAnnotationRange(e, "hh")
                              }
                              onPaste={(e) => e.preventDefault()}
                              onDrop={(e) => e.preventDefault()}
                              onWheelCapture={(e) => {
                                e.target.blur();
                              }}
                            />
                          </span>
                          <small>:</small>
                          <span
                            className={
                              input_time_ranges.max_mm_span
                                ? "input-range-error"
                                : ""
                            }
                          >
                            <TextField
                              type="number"
                              InputProps={{
                                inputProps: { min: 0, max: 59 },
                                classes: { root: "time-field-root" },
                              }}
                              className="time-field"
                              defaultValue={dayjs
                                .utc(annotate_range[1])
                                .format("mm")}
                              onChange={(e) =>
                                updateAnnotationRange(
                                  "max",
                                  "mm",
                                  e.target.value
                                )
                              }
                              onKeyPress={(e) =>
                                validateAnnotationRange(e, "mm")
                              }
                              onPaste={(e) => e.preventDefault()}
                              onDrop={(e) => e.preventDefault()}
                              onWheelCapture={(e) => {
                                e.target.blur();
                              }}
                            />
                          </span>
                          <small>:</small>
                          <span
                            className={
                              input_time_ranges.max_ss_span
                                ? "input-range-error"
                                : ""
                            }
                          >
                            <TextField
                              type="number"
                              InputProps={{
                                inputProps: { min: 0, max: 59 },
                                classes: { root: "time-field-root" },
                              }}
                              className="time-field"
                              defaultValue={dayjs
                                .utc(annotate_range[1])
                                .format("ss")}
                              onChange={(e) =>
                                updateAnnotationRange(
                                  "max",
                                  "ss",
                                  e.target.value
                                )
                              }
                              onKeyPress={(e) =>
                                validateAnnotationRange(e, "ss")
                              }
                              onPaste={(e) => e.preventDefault()}
                              onDrop={(e) => e.preventDefault()}
                              onWheelCapture={(e) => {
                                e.target.blur();
                              }}
                            />
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="duration-info">
                    <span className="duration-lable">
                      <IntlMessages id="newpatient.duration" />
                    </span>
                    <span className="duration-value-wrap">
                      <span className="duration-value">
                        {time_difference &&
                          time_difference[0] +
                            "hr " +
                            time_difference[1] +
                            "min " +
                            time_difference[2] +
                            "sec"}
                      </span>
                      <span className="duration-value-line" />
                    </span>
                    {time_difference_error && (
                      <span className="error-msg">{time_difference_error}</span>
                    )}
                  </div>
                </div>
              )}
            <div className="comment-field">
              {view_annotation_flag &&
                selected_annotation.comment !== "" && (
                  <>
                    <label>
                      <IntlMessages id="dashboard.comments" />
                    </label>
                    <div>{selected_annotation.comment}</div>
                  </>
                )}
              {!view_annotation_flag && (
                <>
                  <label>
                    <IntlMessages id="dashboard.comments" />
                  </label>
                  <TextField
                    onChange={(e) => update_comment(e.target.value)}
                    value={comment}
                    fullWidth
                    variant="outlined"
                    multiline={true}
                    rows={3}
                    rowsMax={4}
                    className="comment-textarea"
                  />
                </>
              )}
              {comment_error && (
                <span className="error-msg">{comment_error}</span>
              )}
            </div>
          </div>
          {view_annotation_flag && (
            <div
              className="annotation-block category-block"
              id="select-label-block"
            >
              <div className="category-title">
                <IntlMessages id="sp.category" />
              </div>
              <List className="category-list">
                <ListItem className="category-item">
                  <div
                    className="category-wrap selected"
                    style={{ background: selected_annotation.color_code }}
                  >
                    <ListItemIcon className="category-icon">
                      <img src={icon_check_white} alt="Icon" />
                    </ListItemIcon>
                    <ListItemText
                      className="category-text"
                      primary={selected_annotation.label}
                    />
                  </div>
                </ListItem>
              </List>
            </div>
          )}
          {!view_annotation_flag &&
            !show_add_category_flag &&
            !show_edit_category_flag &&
            show_category_listing_flag && (
              <div
                className="annotation-block category-block"
                id="select-label-block"
              >
                <div className="category-title">
                  <IntlMessages id="sp.selectcategory" />
                </div>
                <List className="category-list">
                  {annotation_categories &&
                    annotation_categories.map((c, i) => (
                      <ListItem key={"cat" + i} className="category-item">
                        <div
                          className={
                            "category-wrap " +
                            (category && c.label_id == category.label_id
                              ? " selected"
                              : "")
                          }
                          style={{ background: c.color_code }}
                          onClick={() => select_category(c)}
                        >
                          <ListItemIcon className="category-icon">
                            <img src={icon_check_white} alt="Icon" />
                          </ListItemIcon>
                          <ListItemText
                            className="category-text"
                            primary={c.label}
                          />
                        </div>
                        {c.type === "custom" && (
                          <>
                            <ListItemIcon className="category-edit-icon">
                              <img
                                src={icon_edit}
                                title="Edit"
                                alt="Icon"
                                onClick={() => showEditLabelHandle(c.label_id)}
                              />
                            </ListItemIcon>
                            <ListItemIcon className="category-edit-icon">
                              <img
                                src={icon_delete}
                                title="Delete"
                                alt="Icon"
                                onClick={() => deleteCategoryHandle(c.label_id)}
                              />
                            </ListItemIcon>
                          </>
                        )}
                      </ListItem>
                    ))}
                </List>
                {category_error && (
                  <span className="error-msg">{category_error}</span>
                )}
                {!view_annotation_flag &&
                  annotation_categories &&
                  annotation_categories.length < 12 && (
                    <div className="create-cat-link">
                      <span
                        className="annotation-link"
                        onClick={showNewLabelHandle}
                      >
                        <IntlMessages id="sp.createcategory" />
                      </span>
                    </div>
                  )}
              </div>
            )}
          {!view_annotation_flag &&
            !show_category_listing_flag &&
            !show_edit_category_flag &&
            show_add_category_flag && (
              <div
                className="annotation-block category-block"
                id="create-label-block"
              >
                {/* <div className="category-title">Select category</div> */}
                <div className="edit-label-block">
                  <div className="category-title">
                    <IntlMessages id="sp.selectcategorycolor" />
                  </div>
                  <Select
                    options={available_add_category_colours}
                    // defaultValue={annotation_colours[2]}
                    // value={annotation_colours[2]}
                    label="Single select"
                    styles={colourStyles}
                    className="color-selectbox"
                    classNamePrefix="color-select"
                    onChange={(opt) => {
                      set_add_category_color_code(opt.value);
                    }}
                  />
                  {add_category_color_code_error && (
                    <span className="error-msg">
                      {add_category_color_code_error}
                    </span>
                  )}
                </div>
                <div className="edit-label-block">
                  <div className="category-title">
                    <IntlMessages id="sp.cateogrytitle" />
                  </div>
                  <TextField
                    onChange={(e) => set_add_category_label(e.target.value)}
                    value={add_category_label}
                    fullWidth
                    variant="outlined"
                    multiline={true}
                    rows={2}
                    rowsMax={2}
                    className="comment-textarea"
                  />
                  {add_category_label_error && (
                    <span className="error-msg">
                      {add_category_label_error}
                    </span>
                  )}
                </div>
                <div className="cat-link-wrap">
                  <span className="annotation-link" onClick={addCategoryHandle}>
                    <IntlMessages id="sp.addcategory" />
                  </span>
                  <span
                    className="annotation-link"
                    onClick={hideNewLabelHandle}
                  >
                    <IntlMessages id="main.cancel" />
                  </span>
                </div>
              </div>
            )}
          {!view_annotation_flag &&
            show_edit_category_flag &&
            !show_category_listing_flag &&
            !show_add_category_flag && (
              <div
                className="annotation-block category-block"
                id="create-label-block"
              >
                {/* <div className="category-title">Select category</div> */}
                <div className="edit-label-block">
                  <div className="category-title">
                    <IntlMessages id="sp.selectcategorycolor" />
                  </div>
                  <Select
                    options={available_edit_category_colours}
                    // defaultValue={annotation_colours.find(c => c.label_id==edit_category_label_id)}
                    defaultValue={edit_category_color_option}
                    // value={annotation_colours[2]}
                    label="Single select"
                    styles={colourStyles}
                    className="color-selectbox"
                    classNamePrefix="color-select"
                    onChange={(opt) => {
                      set_edit_category_color_code(opt.value);
                    }}
                  />
                  {edit_category_color_code_error && (
                    <span className="error-msg">
                      {edit_category_color_code_error}
                    </span>
                  )}
                </div>
                <div className="edit-label-block">
                  <div className="category-title">
                    <IntlMessages id="sp.categorytitle" />
                  </div>
                  <TextField
                    onChange={(e) => set_edit_category_label(e.target.value)}
                    value={edit_category_label}
                    fullWidth
                    variant="outlined"
                    multiline={true}
                    rows={2}
                    rowsMax={2}
                    className="comment-textarea"
                  />
                  {edit_category_label_error && (
                    <span className="error-msg">
                      {edit_category_label_error}
                    </span>
                  )}
                </div>
                <div className="cat-link-wrap">
                  <span
                    className="annotation-link"
                    onClick={editCategoryHandle}
                  >
                    <IntlMessages id="sp.updatecategory" />
                  </span>
                  <span
                    className="annotation-link"
                    onClick={hideEditLabelHandle}
                  >
                    <IntlMessages id="main.cancel" />
                  </span>
                </div>
              </div>
            )}
        </DialogContent>
        {!view_annotation_flag && (
          <DialogActions className="popup-footer">
            <Button
              className="secondary-button"
              disableRipple={true}
              disableFocusRipple={true}
              onClick={handleClose}
            >
              Cancel
            </Button>
            {edit_annotation_flag &&
              !view_annotation_flag && (
                <Button
                  className="primary-button"
                  disableRipple={true}
                  disableFocusRipple={true}
                  onClick={editAnnotationHandler}
                >
                  <IntlMessages id="ea.update" />
                </Button>
              )}
            {annotate &&
              !edit_annotation_flag &&
              !view_annotation_flag && (
                <Button
                  className="primary-button"
                  disableRipple={true}
                  disableFocusRipple={true}
                  onClick={() => addAnnotationHandler(annotation_kpis)}
                >
                  <IntlMessages id="sp.addannotattions" />
                </Button>
              )}
          </DialogActions>
        )}
      </div>
    </Dialog>
  );
}
